
import { useState } from "react";

const FloatingSupportWidget = ({
  phone    = process.env.REACT_APP_SUPPORT_PHONE    || "",
  whatsapp = process.env.REACT_APP_WHATSAPP_NUMBER  || "",onOpenChange
}) => {
  const [open, setOpen]           = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <>
      <style>{WIDGET_CSS}</style>

      {/* ── Phone FAB ── */}
      <button
        className="fsw-phone-fab"
        onClick={() => {
            setOpen(true);
            onOpenChange?.(true);
          }}
        aria-label="Call Support"
      >
        <span className="fsw-fab-ring" aria-hidden="true" />
        <span className="fsw-fab-inner fsw-fab-inner--phone">
          <PhoneIcon />
        </span>
        <span className="fsw-fab-pulse" aria-hidden="true" />
      </button>

      {/* ── WhatsApp FAB ── */}
      <a
        href={`https://wa.me/${whatsapp.replace(/\D/g, "")}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fsw-wa-fab"
        aria-label="WhatsApp Support"
      >
        <span className="fsw-fab-inner fsw-fab-inner--wa">
          <WhatsAppIcon />
        </span>
      </a>

      {/* ── Expanded card ── */}
      {open && (
        <div className="fsw-card">
          <button
            className="fsw-close"
            onClick={() => {setOpen(false);
              onOpenChange?.(false);
            }}
            aria-label="Close"
          >
            ✕
          </button>

          <div className="fsw-header">
            <span className="fsw-header-icon">🩺</span>
            <div>
              <p className="fsw-header-title">Worried About Your Health?</p>
              <p className="fsw-header-sub">Talk to an Expert Now!</p>
            </div>
          </div>

          <div className="fsw-divider" />

          <a href={`tel:${phone}`} className="fsw-call-btn">
            📞 &nbsp;Call: {formatPhone(phone)}
          </a>

          <a
            href={`https://wa.me/${whatsapp.replace(/\D/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="fsw-wa-btn"
          >
            💬 &nbsp;WhatsApp Us
          </a>

          <p className="fsw-trust">Free · Confidential · Available 24/7</p>

          <button className="fsw-dismiss" onClick={() => {setDismissed(true);onOpenChange?.(false);}}>
            Maybe later
          </button>
        </div>
      )}
    </>
  );
};

/* ── Phone Icon ── */
const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" width="38" height="38" xmlns="http://www.w3.org/2000/svg" fill="none">
    <path
      fill="#ffffff"
      d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.61 21 3 13.39 3 4c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.24 1.02l-2.21 2.2z"
    />
  </svg>
);

/* ── WhatsApp Icon ── */
const WhatsAppIcon = () => (
  <svg viewBox="0 0 32 32" width="38" height="38" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#fff"
      d="M16 2C8.268 2 2 8.268 2 16c0 2.478.651 4.805 1.789 6.82L2 30l7.38-1.766A13.94 13.94 0 0016 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.6a11.55 11.55 0 01-5.89-1.607l-.422-.25-4.38 1.048 1.073-4.266-.276-.437A11.6 11.6 0 014.4 16C4.4 9.59 9.59 4.4 16 4.4c6.41 0 11.6 5.19 11.6 11.6 0 6.41-5.19 11.6-11.6 11.6zm6.37-8.674c-.35-.174-2.07-1.02-2.39-1.137-.32-.116-.554-.174-.787.174-.233.348-.903 1.137-1.107 1.37-.203.232-.407.26-.757.087-.35-.174-1.478-.545-2.814-1.737-1.04-.928-1.742-2.073-1.946-2.422-.204-.348-.022-.536.153-.71.157-.155.35-.406.524-.609.175-.202.233-.348.35-.58.116-.232.058-.435-.03-.609-.086-.174-.786-1.896-1.078-2.596-.284-.682-.573-.59-.787-.6l-.67-.012c-.233 0-.612.087-.932.435-.32.348-1.224 1.196-1.224 2.917 0 1.72 1.253 3.384 1.427 3.616.175.232 2.466 3.766 5.977 5.28.835.36 1.487.576 1.994.737.838.267 1.601.229 2.204.139.672-.1 2.07-.847 2.362-1.664.29-.817.29-1.517.203-1.664-.087-.145-.32-.232-.67-.406z"
    />
  </svg>
);

/* ── Helper ── */
const formatPhone = (p) => {
  const d = p.replace(/\D/g, "");
  if (d.length === 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  return p;
};

/* ── CSS ── */
const WIDGET_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@700;800&family=DM+Sans:wght@400;600&display=swap');

  /* ── Shared FAB size ── */
  .fsw-phone-fab,
  .fsw-wa-fab {
    position: fixed;
    right: 20px;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    z-index: 8888;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ── Phone FAB — bottom position ── */
  .fsw-phone-fab {
    bottom: 110px;
  }

  /* ── WhatsApp FAB — above phone ── */
  .fsw-wa-fab {
    bottom: 196px;
    text-decoration: none;
  }

  /* ── Spinning ring (phone only) ── */
  .fsw-fab-ring {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: conic-gradient(from 0deg, #00e5ff, #00bcd4, #00897b, #006D77, #26c6da, #80deea, #00e5ff);
    animation: fsw-spin 2.4s linear infinite;
    -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px));
    mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px));
  }
  @keyframes fsw-spin { to { transform: rotate(360deg); } }

  /* ── Pulse ripple (phone only) ── */
  .fsw-fab-pulse {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 2px solid rgba(0, 180, 200, 0.5);
    animation: fsw-pulse 2s ease-out infinite;
    pointer-events: none;
  }
  @keyframes fsw-pulse {
    0%   { transform: scale(1);    opacity: 0.7; }
    70%  { transform: scale(1.55); opacity: 0;   }
    100% { transform: scale(1.55); opacity: 0;   }
  }

  /* ── Inner filled circle — shared base ── */
  .fsw-fab-inner {
    position: absolute;
    inset: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  /* Phone inner — teal dark */
  .fsw-fab-inner--phone {
    background: linear-gradient(135deg, #001a1f 0%, #002a30 55%, #003d45 100%);
    box-shadow: 0 6px 20px rgba(0,109,119,0.55), 0 0 18px rgba(0,229,255,0.15) inset;
  }
  .fsw-phone-fab:hover .fsw-fab-inner--phone {
    transform: scale(1.08);
    box-shadow: 0 10px 28px rgba(0,109,119,0.7);
  }

  /* WhatsApp inner — green */
  .fsw-fab-inner--wa {
    inset: 0;
    background: #25D366;
    box-shadow: 0 4px 16px rgba(37,211,102,0.45);
  }
  .fsw-wa-fab:hover .fsw-fab-inner--wa {
    transform: scale(1.08);
    box-shadow: 0 8px 24px rgba(37,211,102,0.6);
  }

  /* ── Card ── */
  .fsw-card {
    position: fixed;
    right: 16px;
    bottom: 300px;
    width: 260px;
    background: #FFFFFF;
    border-radius: 20px;
    box-shadow: 0 16px 48px rgba(0,0,0,0.22), 0 0 0 1px rgba(0,109,119,0.12);
    z-index: 8999;
    overflow: hidden;
    animation: fsw-slide-in 0.3s cubic-bezier(0.34,1.56,0.64,1) forwards;
    font-family: 'DM Sans', sans-serif;
  }
  @keyframes fsw-slide-in {
    from { opacity: 0; transform: translateY(20px) scale(0.95); }
    to   { opacity: 1; transform: translateY(0)    scale(1);    }
  }

  .fsw-close {
    position: absolute; top: 10px; right: 10px;
    background: rgba(255,255,255,0.25); border: none;
    width: 28px; height: 28px; border-radius: 50%;
    cursor: pointer; font-size: 13px; font-weight: 700;
    color: #fff; display: flex; align-items: center;
    justify-content: center; z-index: 2; transition: background 0.2s;
  }
  .fsw-close:hover { background: rgba(255,255,255,0.4); }

  .fsw-header {
    background: linear-gradient(135deg, #003D45 0%, #006D77 55%, #008B98 100%);
    padding: 18px 16px 16px;
    display: flex; align-items: center; gap: 12px; position: relative;
  }
  .fsw-header-icon { font-size: 30px; flex-shrink: 0; filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3)); }
  .fsw-header-title { font-family: 'Sora',sans-serif; font-size: 14px; font-weight: 800; color: #FFFFFF; margin: 0 0 3px; line-height: 1.3; }
  .fsw-header-sub   { font-size: 11px; color: rgba(255,255,255,0.72); margin: 0; }

  .fsw-divider { height: 1px; background: #E2E8F0; }

  .fsw-call-btn {
    display: block; margin: 16px 16px 0; padding: 13px;
    background: linear-gradient(135deg, #006D77, #008B98);
    color: #FFFFFF; font-family: 'Sora',sans-serif; font-size: 15px;
    font-weight: 800; border-radius: 13px; text-align: center;
    text-decoration: none; letter-spacing: 0.3px;
    box-shadow: 0 4px 14px rgba(0,109,119,0.38);
    transition: background 0.25s, transform 0.2s, box-shadow 0.25s;
  }
  .fsw-call-btn:hover {
    background: linear-gradient(135deg, #005F68, #007A85);
    transform: translateY(-2px); box-shadow: 0 8px 20px rgba(0,109,119,0.48);
  }

  .fsw-wa-btn {
    display: block; margin: 10px 16px 0; padding: 13px;
    background: #25D366; color: #FFFFFF;
    font-family: 'Sora',sans-serif; font-size: 15px;
    font-weight: 800; border-radius: 13px; text-align: center;
    text-decoration: none; letter-spacing: 0.3px;
    box-shadow: 0 4px 14px rgba(37,211,102,0.35);
    transition: background 0.25s, transform 0.2s, box-shadow 0.25s;
  }
  .fsw-wa-btn:hover {
    background: #1ebe5d; transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(37,211,102,0.5);
  }

  .fsw-trust {
    font-size: 11px; color: #94A3B8; text-align: center;
    margin: 10px 0 0; padding: 0 16px; letter-spacing: 0.2px;
  }

  .fsw-dismiss {
    display: block; width: 100%; padding: 10px; margin-top: 6px;
    background: none; border: none; font-size: 12px; font-weight: 600;
    color: #CBD5E1; cursor: pointer; text-align: center;
    transition: color 0.2s; margin-bottom: 4px;
  }
  .fsw-dismiss:hover { color: #94A3B8; }

  /* ── Mobile ── */
  @media (max-width: 640px) {
    .fsw-phone-fab { right: 16px; bottom: 80px;  width: 60px; height: 60px; }
    .fsw-wa-fab    { right: 16px; bottom: 154px; width: 60px; height: 60px; }
    .fsw-card      { right: 12px; bottom: 230px; width: calc(100vw - 24px); max-width: 320px; }
  }
`;

export default FloatingSupportWidget;